export const GET_MINIMAL_DASHBOARD_REQUEST = "GET_MINIMAL_DASHBOARD_REQUEST";
export const GET_MINIMAL_DASHBOARD_SUCCESS = "GET_MINIMAL_DASHBOARD_SUCCESS";
export const GET_MINIMAL_DASHBOARD_ERROR = "GET_MINIMAL_DASHBOARD_ERROR";